import {MessageBox} from 'element-ui';
import {Message} from 'element-ui';
import { Notification } from 'element-ui';

import router from '../../router'
import store from '../../vuex'

function convertOptions(options) {
    if (options && options.content) {
        var h = compile(options.content)
        options.message = h;
    }
}
function compile(content){
    return window.app.$createElement(window.Vue.compile(content))
}
function makeDialog(option) {
    var dom = document.createElement('div');
    document.getElementsByTagName('body')[0].appendChild(dom);
    let tpl = '\
        <el-dialog \
            :close-on-click-modal="false" \
            :visible.sync="show" \
            :before-close="handleClose" \
            v-bind="dialogProps"\
            @close="close">\
                <dialogContent  @close="closeDialog" @confirm="confirmDialog" v-model="dialogProps.data"></dialogContent>\
        </el-dialog>';
    var vue = new Vue({
        el: dom,
        router,
        store,
        data () {
            return {
                dialogProps: option,
                show: true,
            }
        },
        template: tpl,
        methods: {
            handleClose(done){
                if (option.beforeClose) {
                    option.beforeClose(done);
                } else {
                    done();
                }
            },
            close() {
                if (option.close) {
                    option.close();
                }
            },

            closeDialog(){
                this.show = false
            },
            confirmDialog(result){
                this.show = false
                option.confirm && option.confirm(result)
            }
        },
        components: {
            dialogContent: option.component,
        },
    });
    return vue;
}

export default {
    open(options){
        convertOptions(options);
        return MessageBox(options)
    },
    alert(message, title, options){
        return MessageBox.alert(message, title, options)
    },
    confirm(message, title, options){
        return MessageBox.confirm(message, title, options)
    },
    showError(errors){
        if(!errors || !errors.length){
            return;
        }
        return this.alert(compile('<div>' + errors.join('<br>') + '</div>'))
    },
    toast(message){
        return Message(message)
    },
    notify(message){
        if(typeof message === 'string'){
            message = {
                message,
                type: 'info'
            }
        }
        return Notification(message)
    },
    success(message){
        return Notification.success({
                    message,
                    type: 'success',
                    duration: 2000,
                })
    },
    dialog(options){
        return makeDialog(options)
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/layer.js